import apiCliente from 'utils/apiCliente';
import { toast } from 'react-toastify';

/**
 * Refresca manualmente el token de Instagram
 * @param {Function} dispatch - Redux dispatch function
 * @returns {Promise<Object>} Resultado del refresco
 */
export const refrescarTokenInstagram = async (dispatch) => {
	try {
		const token = sessionStorage.getItem('token');

		if (!token) {
			toast.error('No hay sesión activa');
			throw new Error('No hay sesión activa');
		}

		const response = await apiCliente.post(
			'/instagram-token/refresh',
			{},
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);

		toast.success('Token de Instagram refrescado exitosamente');
		return response.data;
	} catch (error) {
		console.error('Error al refrescar token de Instagram:', error);

		if (error.response?.status === 401) {
			toast.error('Sesión expirada. Por favor, inicia sesión nuevamente.');
			window.location.href = '/login';
		} else {
			toast.error(error.response?.data?.error || 'Error al refrescar token de Instagram');
		}

		throw new Error(error.response?.data?.error || 'Error al refrescar token de Instagram');
	}
};
